import { useEffect, useRef, useState } from 'react';
import { useOnClickOutside } from './useOnClickOutside';

export const useTabDropdown = (tabs, setActiveTab) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedTab, setSelectedTab] = useState(tabs[0]);
  const dropdownRef = useRef(null);

  useOnClickOutside(dropdownRef, () => setIsOpen(false));

  useEffect(() => {
    if (setActiveTab) {
      setActiveTab(selectedTab.id);
    }
  }, [selectedTab, setActiveTab]);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const selectTab = (tab) => {
    setSelectedTab(tab);
    setIsOpen(false);
  };

  return { isOpen, selectedTab, dropdownRef, toggleDropdown, selectTab };
};
